CityInfo = [
  {
    value: 1, label: '北京', children: [
      {
        value: 1, label: '北京市'
      }
    ]
  },
  {
    value: 2, label: '天津', children: [
      {
        value: 2, label: '天津市'
      }
    ]
  },
  {
    value: 3, label: '河北', children: [
      {
        value: 3, label: '石家庄市'
      },
      {
        value: 4, label: '唐山市'
      },
      {
        value: 5, label: '秦皇岛市'
      },
      {
        value: 6, label: '邯郸市'
      },
      {
        value: 7, label: '邢台市'
      },
      {
        value: 8, label: '保定市'
      },
      {
        value: 9, label: '张家口市'
      },
      {
        value: 10, label: '承德市'
      },
      {
        value: 11, label: '沧州市'
      },
      {
        value: 12, label: '廊坊市'
      },
      {
        value: 13, label: '衡水市'
      }
    ]
  },
  {
    value: 4, label: '山西', children: [
      {
        value: 14, label: '太原市'
      },
      {
        value: 15, label: '大同市'
      },
      {
        value: 16, label: '阳泉市'
      },
      {
        value: 17, label: '长治市'
      },
      {
        value: 18, label: '晋城市'
      },
      {
        value: 19, label: '朔州市'
      },
      {
        value: 20, label: '晋中市'
      },
      {
        value: 21, label: '运城市'
      },
      {
        value: 22, label: '忻州市'
      },
      {
        value: 23, label: '临汾市'
      },
      {
        value: 24, label: '吕梁市'
      }
    ]
  },
  {
    value: 5, label: '内蒙古', children: [
      {
        value: 25, label: '呼和浩特市'
      },
      {
        value: 26, label: '包头市'
      },
      {
        value: 27, label: '乌海市'
      },
      {
        value: 28, label: '赤峰市'
      },
      {
        value: 29, label: '通辽市'
      },
      {
        value: 30, label: '鄂尔多斯市'
      },
      {
        value: 31, label: '呼伦贝尔市'
      },
      {
        value: 32, label: '巴彦淖尔市'
      },
      {
        value: 33, label: '乌兰察布市'
      },
      {
        value: 34, label: '兴安盟'
      },
      {
        value: 35, label: '锡林郭勒盟'
      },
      {
        value: 36, label: '阿拉善盟'
      }
    ]
  },
  {
    value: 6, label: '辽宁', children: [
      {
        value: 37, label: '沈阳市'
      },
      {
        value: 38, label: '大连市'
      },
      {
        value: 39, label: '鞍山市'
      },
      {
        value: 40, label: '抚顺市'
      },
      {
        value: 41, label: '本溪市'
      },
      {
        value: 42, label: '丹东市'
      },
      {
        value: 43, label: '锦州市'
      },
      {
        value: 44, label: '营口市'
      },
      {
        value: 45, label: '阜新市'
      },
      {
        value: 46, label: '辽阳市'
      },
      {
        value: 47, label: '盘锦市'
      },
      {
        value: 48, label: '铁岭市'
      },
      {
        value: 49, label: '朝阳市'
      },
      {
        value: 50, label: '葫芦岛市'
      }
    ]
  },
  {
    value: 7, label: '吉林', children: [
      {
        value: 51, label: '长春市'
      },
      {
        value: 52, label: '吉林市'
      },
      {
        value: 53, label: '四平市'
      },
      {
        value: 54, label: '辽源市'
      },
      {
        value: 55, label: '通化市'
      },
      {
        value: 56, label: '白山市'
      },
      {
        value: 57, label: '松原市'
      },
      {
        value: 58, label: '白城市'
      },
      {
        value: 59, label: '延边'
      }
    ]
  },
  {
    value: 8, label: '黑龙江', children: [
      {
        value: 60, label: '哈尔滨市'
      },
      {
        value: 61, label: '齐齐哈尔市'
      },
      {
        value: 62, label: '鸡西市'
      },
      {
        value: 63, label: '鹤岗市'
      },
      {
        value: 64, label: '双鸭山市'
      },
      {
        value: 65, label: '大庆市'
      },
      {
        value: 66, label: '伊春市'
      },
      {
        value: 67, label: '佳木斯市'
      },
      {
        value: 68, label: '七台河市'
      },
      {
        value: 69, label: '牡丹江市'
      },
      {
        value: 70, label: '黑河市'
      },
      {
        value: 71, label: '绥化市'
      },
      {
        value: 72, label: '大兴安岭地区'
      }
    ]
  },
  {
    value: 9, label: '上海', children: [
      {
        value: 73, label: '上海市'
      }
    ]
  },
  {
    value: 10, label: '江苏', children: [
      {
        value: 74, label: '南京市'
      },
      {
        value: 75, label: '无锡市'
      },
      {
        value: 76, label: '徐州市'
      },
      {
        value: 77, label: '常州市'
      },
      {
        value: 78, label: '苏州市'
      },
      {
        value: 79, label: '南通市'
      },
      {
        value: 80, label: '连云港市'
      },
      {
        value: 81, label: '淮安市'
      },
      {
        value: 82, label: '盐城市'
      },
      {
        value: 83, label: '扬州市'
      },
      {
        value: 84, label: '镇江市'
      },
      {
        value: 85, label: '泰州市'
      },
      {
        value: 86, label: '宿迁市'
      }
    ]
  },
  {
    value: 11, label: '浙江', children: [
      {
        value: 87, label: '杭州市'
      },
      {
        value: 88, label: '宁波市'
      },
      {
        value: 89, label: '温州市'
      },
      {
        value: 90, label: '嘉兴市'
      },
      {
        value: 91, label: '湖州市'
      },
      {
        value: 92, label: '绍兴市'
      },
      {
        value: 93, label: '金华市'
      },
      {
        value: 94, label: '衢州市'
      },
      {
        value: 95, label: '舟山市'
      },
      {
        value: 96, label: '台州市'
      },
      {
        value: 97, label: '丽水市'
      }
    ]
  },
  {
    value: 12, label: '安徽', children: [
      {
        value: 98, label: '合肥市'
      },
      {
        value: 99, label: '芜湖市'
      },
      {
        value: 100, label: '蚌埠市'
      },
      {
        value: 101, label: '淮南市'
      },
      {
        value: 102, label: '马鞍山市'
      },
      {
        value: 103, label: '淮北市'
      },
      {
        value: 104, label: '铜陵市'
      },
      {
        value: 105, label: '安庆市'
      },
      {
        value: 106, label: '黄山市'
      },
      {
        value: 107, label: '滁州市'
      },
      {
        value: 108, label: '阜阳市'
      },
      {
        value: 109, label: '宿州市'
      },
      {
        value: 110, label: '巢湖市'
      },
      {
        value: 111, label: '六安市'
      },
      {
        value: 112, label: '亳州市'
      },
      {
        value: 113, label: '池州市'
      },
      {
        value: 114, label: '宣城市'
      }
    ]
  },
  {
    value: 13, label: '福建', children: [
      {
        value: 115, label: '福州市'
      },
      {
        value: 116, label: '厦门市'
      },
      {
        value: 117, label: '莆田市'
      },
      {
        value: 118, label: '三明市'
      },
      {
        value: 119, label: '泉州市'
      },
      {
        value: 120, label: '漳州市'
      },
      {
        value: 121, label: '南平市'
      },
      {
        value: 122, label: '龙岩市'
      },
      {
        value: 123, label: '宁德市'
      }
    ]
  },
  {
    value: 14, label: '江西', children: [
      {
        value: 124, label: '南昌市'
      },
      {
        value: 125, label: '景德镇市'
      },
      {
        value: 126, label: '萍乡市'
      },
      {
        value: 127, label: '九江市'
      },
      {
        value: 128, label: '新余市'
      },
      {
        value: 129, label: '鹰潭市'
      },
      {
        value: 130, label: '赣州市'
      },
      {
        value: 131, label: '吉安市'
      },
      {
        value: 132, label: '宜春市'
      },
      {
        value: 133, label: '抚州市'
      },
      {
        value: 134, label: '上饶市'
      }
    ]
  },
  {
    value: 15, label: '山东', children: [
      {
        value: 135, label: '济南市'
      },
      {
        value: 136, label: '青岛市'
      },
      {
        value: 137, label: '淄博市'
      },
      {
        value: 138, label: '枣庄市'
      },
      {
        value: 139, label: '东营市'
      },
      {
        value: 140, label: '烟台市'
      },
      {
        value: 141, label: '潍坊市'
      },
      {
        value: 142, label: '济宁市'
      },
      {
        value: 143, label: '泰安市'
      },
      {
        value: 144, label: '威海市' 
      },
      {
        value: 145, label: '日照市'
      },
      {
        value: 146, label: '莱芜市'
      },
      {
        value: 147, label: '临沂市'
      },
      {
        value: 148, label: '德州市'
      },
      {
        value: 149, label: '聊城市'
      },
      {
        value: 150, label: '滨州市'
      },
      {
        value: 151, label: '荷泽市'
      }
    ]
  },
  {
    value: 16, label: '河南', children: [
      {
        value: 152, label: '郑州市'
      },
      {
        value: 153, label: '开封市'
      },
      {
        value: 154, label: '洛阳市'
      },
      {
        value: 155, label: '平顶山市'
      },
      {
        value: 156, label: '安阳市'
      },
      {
        value: 157, label: '鹤壁市'
      },
      {
        value: 158, label: '新乡市'
      },
      {
        value: 159, label: '焦作市'
      },
      {
        value: 160, label: '濮阳市'
      },
      {
        value: 161, label: '许昌市'
      },
      {
        value: 162, label: '漯河市'
      },
      {
        value: 163, label: '三门峡市'
      },
      {
        value: 164, label: '南阳市'
      },
      {
        value: 165, label: '商丘市'
      },
      {
        value: 166, label: '信阳市'
      },
      {
        value: 167, label: '周口市'
      },
      {
        value: 168, label: '驻马店市'
      }
    ]
  },
  {
    value: 17, label: '湖北', children: [
      {
        value: 169, label: '武汉市'
      },
      {
        value: 170, label: '黄石市'
      },
      {
        value: 171, label: '十堰市'
      },
      {
        value: 172, label: '宜昌市'
      },
      {
        value: 173, label: '襄樊市'
      },
      {
        value: 174, label: '鄂州市'
      },
      {
        value: 175, label: '荆门市'
      },
      {
        value: 176, label: '孝感市'
      },
      {
        value: 177, label: '荆州市'
      },
      {
        value: 178, label: '黄冈市'
      },
      {
        value: 179, label: '咸宁市'
      },
      {
        value: 180, label: '随州市'
      },
      {
        value: 181, label: '恩施'
      },
      {
        value: 182, label: '神农架'
      }
    ]
  },
  {
    value: 18, label: '湖南', children: [
      {
        value: 183, label: '长沙市'
      },
      {
        value: 184, label: '株洲市'
      },
      {
        value: 185, label: '湘潭市'
      },
      {
        value: 186, label: '衡阳市'
      },
      {
        value: 187, label: '邵阳市'
      },
      {
        value: 188, label: '岳阳市'
      },
      {
        value: 189, label: '常德市'
      },
      {
        value: 190, label: '张家界市'
      },
      {
        value: 191, label: '益阳市'
      },
      {
        value: 192, label: '郴州市'
      },
      {
        value: 193, label: '永州市'
      },
      {
        value: 194, label: '怀化市'
      },
      {
        value: 195, label: '娄底市'
      },
      {
        value: 196, label: '湘西'
      }
    ]
  },
  {
    value: 19, label: '广东', children: [
      {
        value: 197, label: '广州市'
      },
      {
        value: 198, label: '韶关市'
      },
      {
        value: 199, label: '深圳市'
      },
      {
        value: 200, label: '珠海市'
      },
      {
        value: 201, label: '汕头市'
      },
      {
        value: 202, label: '佛山市'
      },
      {
        value: 203, label: '江门市'
      },
      {
        value: 204, label: '湛江市'
      },
      {
        value: 205, label: '茂名市'
      },
      {
        value: 206, label: '肇庆市'
      },
      {
        value: 207, label: '惠州市'
      },
      {
        value: 208, label: '梅州市'
      },
      {
        value: 209, label: '汕尾市'
      },
      {
        value: 210, label: '河源市'
      },
      {
        value: 211, label: '阳江市'
      },
      {
        value: 212, label: '清远市'
      },
      { value: 213, label: '东莞市' },
      { value: 214, label: '中山市' },
      {
        value: 215, label: '潮州市'
      },
      {
        value: 216, label: '揭阳市'
      },
      {
        value: 217, label: '云浮市'
      }
    ]
  },
  {
    value: 20, label: '广西', children: [
      {
        value: 218, label: '南宁市'
      },
      {
        value: 219, label: '柳州市'
      },
      {
        value: 220, label: '桂林市'
      },
      {
        value: 221, label: '梧州市'
      },
      {
        value: 222, label: '北海市'
      },
      {
        value: 223, label: '防城港市'
      },
      {
        value: 224, label: '钦州市'
      },
      {
        value: 225, label: '贵港市'
      },
      {
        value: 226, label: '玉林市'
      },
      {
        value: 227, label: '百色市'
      },
      {
        value: 228, label: '贺州市'
      },
      {
        value: 229, label: '河池市'
      },
      {
        value: 230, label: '来宾市'
      },
      {
        value: 231, label: '崇左市'
      }
    ]
  },
  {
    value: 21, label: '海南', children: [
      {
        value: 232, label: '海口市'
      },
      {
        value: 233, label: '三亚市'
      }
    ]
  },
  {
    value: 22, label: '重庆', children: [
      {
        value: 234, label: '重庆市'
      }
    ]
  },
  {
    value: 23, label: '四川', children: [
      {
        value: 235, label: '成都市'
      },
      {
        value: 236, label: '自贡市'
      },
      {
        value: 237, label: '攀枝花市'
      },
      {
        value: 238, label: '泸州市'
      },
      {
        value: 239, label: '德阳市'
      },
      {
        value: 240, label: '绵阳市'
      },
      {
        value: 241, label: '广元市'
      },
      {
        value: 242, label: '遂宁市'
      },
      {
        value: 243, label: '内江市'
      },
      {
        value: 244, label: '乐山市'
      },
      {
        value: 245, label: '南充市'
      },
      {
        value: 246, label: '眉山市'
      },
      {
        value: 247, label: '宜宾市'
      },
      {
        value: 248, label: '广安市'
      },
      {
        value: 249, label: '达州市'
      },
      {
        value: 250, label: '雅安市'
      },
      {
        value: 251, label: '巴中市'
      },
      {
        value: 252, label: '资阳市'
      },
      {
        value: 253, label: '阿坝'
      },
      {
        value: 254, label: '甘孜'
      },
      {
        value: 255, label: '凉山'
      }
    ]
  },
  {
    value: 24, label: '贵州', children: [
      {
        value: 256, label: '贵阳市'
      },
      {
        value: 257, label: '六盘水市'
      },
      {
        value: 258, label: '遵义市'
      },
      {
        value: 259, label: '安顺市'
      },
      {
        value: 260, label: '铜仁地区'
      },
      {
        value: 261, label: '黔西'
      },
      {
        value: 262, label: '毕节地区'
      },
      {
        value: 263, label: '黔东'
      },
      {
        value: 264, label: '黔南'
      }
    ]
  },
  {
    value: 25, label: '云南', children: [
      {
        value: 265, label: '昆明市'
      },
      {
        value: 266, label: '曲靖市'
      },
      {
        value: 267, label: '玉溪市'
      },
      {
        value: 268, label: '保山市'
      },
      {
        value: 269, label: '昭通市'
      },
      {
        value: 270, label: '丽江市'
      },
      {
        value: 271, label: '思茅市'
      },
      {
        value: 272, label: '临沧市'
      },
      {
        value: 273, label: '楚雄'
      },
      {
        value: 274, label: '红河'
      },
      {
        value: 275, label: '文山'
      },
      {
        value: 276, label: '西双版纳'
      },
      {
        value: 277, label: '大理'
      },
      {
        value: 278, label: '德宏'
      },
      {
        value: 279, label: '怒江'
      },
      {
        value: 280, label: '迪庆'
      }
    ]
  },
  {
    value: 26, label: '西藏', children: [
      {
        value: 281, label: '拉萨市'
      },
      {
        value: 282, label: '昌都地区'
      },
      {
        value: 283, label: '山南地区'
      },
      {
        value: 284, label: '日喀则地区'
      },
      {
        value: 285, label: '那曲地区'
      },
      {
        value: 286, label: '阿里地区'
      },
      {
        value: 287, label: '林芝地区'
      }
    ]
  },
  {
    value: 27, label: '陕西', children: [
      {
        value: 288, label: '西安市'
      },
      {
        value: 289, label: '铜川市'
      },
      {
        value: 290, label: '宝鸡市'
      },
      {
        value: 291, label: '咸阳市'
      },
      {
        value: 292, label: '渭南市'
      },
      {
        value: 293, label: '延安市'
      },
      {
        value: 294, label: '汉中市'
      },
      {
        value: 295, label: '榆林市'
      },
      {
        value: 296, label: '安康市'
      },
      {
        value: 297, label: '商洛市'
      }
    ]
  },
  {
    value: 28, label: '甘肃', children: [
      {
        value: 298, label: '兰州市'
      },
      { value: 299, label: '嘉峪关市', children: [] },
      {
        value: 300, label: '金昌市'
      },
      {
        value: 301, label: '白银市'
      },
      {
        value: 302, label: '天水市'
      },
      {
        value: 303, label: '武威市'
      },
      {
        value: 304, label: '张掖市'
      },
      {
        value: 305, label: '平凉市'
      },
      {
        value: 306, label: '酒泉市'
      },
      {
        value: 307, label: '庆阳市'
      },
      {
        value: 308, label: '定西市'
      },
      {
        value: 309, label: '陇南市'
      },
      {
        value: 310, label: '临夏'
      },
      {
        value: 311, label: '甘南'
      }
    ]
  },
  {
    value: 29, label: '青海', children: [
      {
        value: 312, label: '西宁市'
      },
      {
        value: 313, label: '海东地区'
      },
      {
        value: 314, label: '海北'
      },
      {
        value: 315, label: '黄南'
      },
      {
        value: 316, label: '海南'
      },
      {
        value: 317, label: '果洛'
      },
      {
        value: 318, label: '玉树'
      },
      {
        value: 319, label: '海西'
      }
    ]
  },
  {
    value: 30, label: '宁夏', children: [
      {
        value: 320, label: '银川市'
      },
      {
        value: 321, label: '石嘴山市'
      },
      {
        value: 322, label: '吴忠市'
      },
      {
        value: 323, label: '固原市'
      },
      {
        value: 324, label: '中卫市'
      }
    ]
  },
  {
    value: 31, label: '新疆', children: [
      {
        value: 325, label: '乌鲁木齐市'
      },
      {
        value: 326, label: '克拉玛依市'
      },
      {
        value: 327, label: '吐鲁番地区'
      },
      {
        value: 328, label: '哈密地区'
      },
      {
        value: 329, label: '昌吉'
      },
      {
        value: 330, label: '博尔塔拉'
      },
      {
        value: 331, label: '巴音郭楞'
      },
      {
        value: 332, label: '阿克苏地区'
      },
      {
        value: 333, label: '克孜勒苏柯尔克孜'
      },
      {
        value: 334, label: '喀什地区'
      },
      {
        value: 335, label: '和田地区'
      },
      {
        value: 336, label: '伊犁哈萨克'
      },
      {
        value: 337, label: '塔城地区'
      },
      {
        value: 338, label: '阿勒泰地区'
      },
      { value: 339, label: '石河子市' },
      { value: 340, label: '阿拉尔市' },
      { value: 341, label: '图木舒克市' },
      { value: 342, label: '五家渠市' }
    ]
  },
  {
    value: 32, label: '香港', children: [
      { value: 343, label: '香港' }
    ]
  },
  {
    value: 33, label: '澳门', children: [
      { value: 344, label: '澳门' }
    ]
  },
  {
    value: 34, label: '台湾', children: [
      { value: 345, label: '台湾' }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/utils/city-data-2d.js